import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../../images/location_new/uk-mobile/working_tek.webp";
import { Link } from "gatsby";

function CaseSection({ handleShow }) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Why Work with <span>TekRevol?</span>
              </h2>
            </div>
            <p>
              TekRevol is an expert-led, full-cycle mobile app development
              company in the UK. We build scalable mobile app solutions with
              interactive frontends and secure backends with a keen focus on
              user engagement, business growth, and future readiness.
            </p>
            <h4>High-Performing Mobile Apps for Sustainable Business Growth</h4>
            <p>
              TekRevol's mobile app development services in the UK focus on
              scalable business growth through high-performing mobile
              applications. Over 8 years, we've collaborated with
              multinationals, SMBs, and entrepreneurs, efficiently overcoming
              app development challenges.
            </p>
            <p>
              Our UK team of top app developers delivers disruptive mobile
              applications with exceptional skill and experience. TekRevol now
              operates globally, providing diverse digital solutions to
              businesses of all sizes.
            </p>
            <button
              onClick={handleShow}
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let’s Build Your Chart-Topping App
            </button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
